import { SALON_DETAILS_ERROR, SALON_DETAILS_REQUEST, SALON_DETAILS_SUCCESS } from 'actions/fetchSalon.types';
import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';

const fetchSalon = (salonId) => ({
  ATAG: 'fetchSalon',
  [AUTH_API]: {
    ...authenticatedEndpoint({ pinSafe: true }),
    ...jsonEndpoint(H.get, `salon/${salonId}/`),
    params: { method: H.get, salonId },
    types: [SALON_DETAILS_REQUEST, SALON_DETAILS_SUCCESS, SALON_DETAILS_ERROR],
  },
});

// noinspection JSUnusedGlobalSymbols
export default fetchSalon;
